module.exports = __webpack_public_path__ + "static/media/MPI New Reproting Ietterhead 30-07-2024 Footer.395b37a2.jpeg";